module.exports = __webpack_public_path__ + "img/appointment_btn.4e57bd46.png";